export default "__VITE_ASSET__BkRMtiOy__"